<template>
  <div>
    <div @click="openSeqRegionDetail" :id="svgId" class="svgPic"></div>
    <el-dialog :title="bigSVG" :visible.sync="showSVG">
      <div :id="'big-' + svgId" class="big-svgpic"></div>
    </el-dialog>
  </div>
</template>

<script>
// import $ from 'jquery'
import SeqRegion from '@/assets/report/seqRegion'
export default {
  data () {
    return {
      showSVG: false
    }
  },
  props: {
    svgId: {
      type: String,
      required: true
    },
    svgData: {
      type: String,
      required: true
    },
    retinue: {
      type: Object
    },
    bigSVG: {
      type: String,
      required: true
    }
  },
  mounted () {
    this.creteSvg()
  },
  methods: {
    openSeqRegionDetail () {
      this.showSVG = true
      setTimeout(() => {
        let conf = {
          elem: '#big-' + this.svgId,
          lineData: this.retinue.curStanardFeatureData,
          rectData: [
            { region: this.retinue.posMsg[this.bigSVG], color: '#FFD700' },
            { region: this.retinue.queryPos, color: '#FF0000', height: 0.9 }
          ],
          viewModel: 'detail',
          lineDataPositions: this.retinue.curlineDataPositions
        }
        SeqRegion.render(conf)
      }, 0)
    },
    creteSvg () {
      let conf = {
        elem: '#' + this.svgId,
        lineData: this.retinue.curStanardFeatureData,
        rectData: [
          { region: this.retinue.posMsg[this.svgData], color: '#FFD700' },
          { region: this.retinue.queryPos, color: '#FF0000', height: 0.9 }
        ],
        viewModel: 'simple',
        lineDataPositions: this.retinue.curlineDataPositions
      }
      SeqRegion.render(conf)
    }
  }
}
</script>

<style>
.svgPic {
  width: 220px;
  height: 20px;
}
.big-svgpic {
  width: 700px;
  height: 350px;
  margin: auto;
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/svgPicture.vue